module.exports = __webpack_public_path__ + "img/pixabay.bac5a38b.jpg";